import { useElementHeightBySelector } from './useElementHeightBySelector';
import { useStripeHeaderStickyOffset } from './useStripeHeaderStickyOffset';

const STRIPE_HEADER_CLASS = 'g-stripe';

export function useMultiStripeHeaderStickyOffset(): number {
    const stickyOffset = useStripeHeaderStickyOffset();
    const offset = useElementHeightBySelector(`.${STRIPE_HEADER_CLASS}`);

    return stickyOffset + offset;
}
